import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import Layout from '../../components/Layout'
import LeaveDetails from '../../pages/LeaveDetails'
import Loading from '../../components/Base/Loading'
import {leavesActions, leavesSelectors} from "../../store/leaves";
import {connect} from "react-redux";

/* Container for New Posts page */

class LeaveDetailsContainer extends Component {
	id = this.props.match.params.leave;
	state = {
		details: null,
		loading: true,
		isFaculty: true,
	};

	componentDidMount() {

		const {updateDetails, details} = this.props;

		if(details !== undefined){
			this.setState({loading: false})
		}
		// fetch data
		// const data = {
		// 	status: 'Pending',
		// 	type: 'Vacation Leave',
		// 	leave_by: 'Parents',
		// 	return_by: "Parents",
		// 	start_date: 1553308929,
		// 	end_date: 1553318929,
		// 	host: 'Mom',
		// 	destination: 'New York City'
		// };

		this.listener = this.props.firebase.leave(this.id).onSnapshot(async snapshot => {

			let data = {id: snapshot.id, ...snapshot.data()}

			let parents = [];
			if(data && data.host) {
				for (let i in data.host) {
					let parentRef = await this.props.firebase.parent(data.host[i]).get();
					parents.push({id: parentRef.id, ...parentRef.data()})
				}
			}

			data.hosts = parents;

			updateDetails(data)
			this.setState({details: data, loading: false})
		});

		// this.setState({details: data, loading: false})
	}

	componentWillUnmount() {
		this.listener()
	}

	render() {
		const { loading} = this.state;
		const { profile, details} = this.props;
		return (
			<Layout {...this.props} noSideBar noFooter type={`${!loading && details.status}`}>
				{profile === null || profile === undefined ? <Loading/> :
					<LeaveDetails {...this.props} type={`${!loading && details.status}`}
					              loading={loading} details={details}/>}
			</Layout>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	loading: leavesSelectors.isLoading(state.leaves),
	details: leavesSelectors.refreshPostWithId(state.leaves, ownProps.match.params.leave)

});

const mapDispatchToProps = (dispatch) => ({
	updateDetails: (data) => dispatch(leavesActions.updateDetails(data)),

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeaveDetailsContainer));
